import { render, staticRenderFns } from "./Char1.vue?vue&type=template&id=7670ef8d&"
import script from "./Char1.vue?vue&type=script&lang=js&"
export * from "./Char1.vue?vue&type=script&lang=js&"
import style0 from "./Char1.vue?vue&type=style&index=0&id=7670ef8d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports